import BaseForm from 'nast-form'

/**
 *
 */
export default class NastForm extends BaseForm {

}
